import React from 'react';
import {
	FaSearch,
	FaRegBell,
	FaUserCircle,
	FaMoon,
	FaSun
} from 'react-icons/fa';
import { setTheme } from '../../../redux/actions/themeAction';
import { useDispatch } from 'react-redux';

import './topNavigation.css';
import { BsFolder2 } from 'react-icons/bs';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { useNavigate } from 'react-router-dom';
import { setTab } from '../../../redux/actions/sideBarAction';
import {
	SET_SEARCH_INPUT_VALUE,
	SET_SEARCH_QUERY
} from '../../../redux/types/types';

export default function TopNavigation() {
	const BellIcon = () => (
		<FaRegBell size="24" className="top-navigation-icon" />
	);

	const UserCircle = () => {
		const { selectedTab } = useTypedSelector((state) => state.sidebar);
		const { user }: any = useTypedSelector((state) => state.auth);

		const dispatch = useDispatch();

		const navigate = useNavigate();

		function handleClick() {
			console.log(user);
			navigate(`user/${user._id}`);
		}
		return (
			<FaUserCircle
				size="24"
				className={
					selectedTab === 'profile'
						? 'top-navigation-icon-active'
						: 'top-navigation-icon'
				}
				onClick={() => {
					dispatch(setTab('profile'));
					return handleClick();
				}}
			/>
		);
	};
	const HashtagIcon = () => (
		<BsFolder2 size="28" className="title-hashtag ml-5" />
	);

	const Title = () => {
		const { selectedSection } = useTypedSelector((state) => state.sidebar);
		return <h5 className="title-text">{selectedSection}</h5>;
	};

	return (
		<div className="top-navigation">
			<HashtagIcon />
			<Title />
			<ThemeIcon />
			<Search />
			<BellIcon />
			<UserCircle />
		</div>
	);
}

function ThemeIcon() {
	const { dark } = useTypedSelector((state) => state.theme);
	const dispatch = useDispatch();

	return (
		<span onClick={() => dispatch(setTheme(dark))}>
			{dark ? (
				<FaSun size="24" className="top-navigation-icon" />
			) : (
				<FaMoon size="24" className="top-navigation-icon" />
			)}
		</span>
	);
}

const Search = () => {
	const {
		activated,
		searchPlaceholder,
		searchInputValue
	}: {
		activated: boolean;
		searchPlaceholder: string;
		searchInputValue: string;
	} = useTypedSelector((state) => state.searchbar);

	const dispatch = useDispatch();
	const onChange = (e: any) =>
		dispatch({ type: SET_SEARCH_INPUT_VALUE, name: e.target.value });
	return (
		<>
			{activated && (
				<form
					className="search"
					onSubmit={(e) => {
						e.preventDefault();
						dispatch({ type: SET_SEARCH_QUERY, payload: searchInputValue });
					}}
				>
					<input
						className="search-input"
						type="text"
						placeholder={searchPlaceholder}
						onChange={onChange}
						value={searchInputValue}
					/>
					<FaSearch
						size="18"
						className="text-purple-600 my-auto cursor-pointer"
						onClick={() => {
							dispatch({ type: SET_SEARCH_QUERY, payload: searchInputValue });
						}}
					/>
				</form>
			)}
		</>
	);
};
